export const formatDateToAPIFormat = (i18n, date) => {
  if (!date) {
    return '1/1/3000';
  }

  return i18n.formatDate(date, {
    raw: 'M/d/yyyy',
  });
};

export const parseDateFromAPIFormat = (i18n, date) => {
  if (!date) {
    return i18n.getString(_TL_('None'));
  }

  return i18n.dateFormatter({ timeZone: 'UTC' })(new Date(date));
};
